<template>
  <section id="login">
    <div style="margin-top:100px; margin-bottom:150px">
      <!-- Login Form -->

      <div class="container h-100 d-flex justify-content-center">
        <div class="login my-auto">
          <button type="button" aria-label="Close" class="close" @click="volver()">×</button>

          <transition name="slideAnim" type="animation" appear mode="out-in">
            <div v-if="!arkidian && !adulto" key="pregunta" class="container modal-arkidia">
              <h3 style="text-align:center; padding-bottom:15px">Registrarme en Arkidia</h3>
              <h5 style="text-align:center; padding-bottom:15px">¿Sos adulto o arkidian?</h5>

              <div class="row" style="justify-content:center">
                <div
                  class="card categoria"
                  @click="adulto=true"
                  style="text-align: center; width:200px"
                >
                  <img
                    src="public/images/site/gran-arkidian.svg"
                    width="100px"
                    alt="Arkidia"
                    style="align-self:center; padding:10px"
                  />
                  <h4 style="padding:10px">Adulto</h4>
                </div>
                <div
                  class="card categoria"
                  @click="arkidian=true"
                  style="text-align: center; width:200px"
                >
                  <img
                    src="public/images/site/mini-arkidian.svg"
                    width="100px"
                    alt="Arkidia"
                    style="align-self:center; padding:10px"
                  />
                  <h4 style="padding:10px">Arkidian</h4>
                </div>
              </div>
            </div>

            <div v-if="arkidian" key="arkidian" class="container modal-arkidia">
              <h3 style="text-align:center; padding-bottom:15px">Registrarme en Arkidia</h3>
              <h5
                style="text-align:center; padding-bottom:15px"
              >Para usar Arkida necesitarás que un adulto te haga un usuario</h5>
              <img
                src="public/images/site/no-challenge.svg"
                width="300px"
                alt="Arkidia"
                style="align-self:center; padding:10px"
              />
              <div>
                <button type="button" class="btn boton-primario" @click="arkidian=false">Volver</button>
              </div>
            </div>

            <form v-if="adulto" key="padre" class="container modal-arkidia" style="text-align:left">
              <h3 style="text-align:center; padding-bottom:15px">Registrarme en Arkidia</h3>

              <div class="form-group">
                <label>Nombre</label>
                <input
                  type="name"
                  class="form-control"
                  v-model="register.nombre"
                  placeholder="Ingresá tu usuario"
                />
              </div>
              <div class="form-group">
                <label>Apellido</label>
                <input
                  type="lastname"
                  class="form-control"
                  v-model="register.apellido"
                  placeholder="Ingresá tu apellido"
                />
              </div>
              <div class="form-group">
                <label>Correo electrónico</label>
                <input
                  type="email"
                  class="form-control"
                  v-model="register.mail"
                  placeholder="Ingresá tu correo electrónico"
                />
              </div>

              <div class="form-group">
                <label>Contraseña</label>
                <input
                  type="password"
                  class="form-control"
                  v-model="register.password"
                  placeholder="Ingresá tu contraseña"
                />
              </div>

              <div class="form-group">
                <label>Repetir contraseña</label>
                <input
                  type="password"
                  class="form-control"
                  v-model="register.passwordC"
                  placeholder="Ingresá tu contraseña nuevamente"
                />
              </div>
              <transition name="slideAnim" type="animation" appear mode="out-in">
                <div v-if="errorMessage" class="alert alert-danger" role="alert">{{errorMessage}}</div>
              </transition>
              <router-link
                to="/Recuperar"
                tag="h6"
                class="olvide-password"
                v-if="existeUsuario"
              >Olvidé mi contraseña</router-link>

              <b-form-checkbox
                id="checkbox-1"
                v-model="status"
                name="checkbox-1"
                value="accepted"
                unchecked-value="not_accepted"
              >
                <div style="margin-bottom:20px">
                  Soy adulto y acepto los
                  <a style="cursor:pointer;" @click="verContrato">
                    <b>Términos y condiciones</b>
                  </a>
                </div>
              </b-form-checkbox>

              <transition name="slideAnim" type="animation" appear mode="in-out">
                <div v-if="status=='accepted'" style="text-align:center">
                  <button
                    type="button"
                    class="btn boton-primario"
                    @click="hacerRegistro(register)"
                  >Registrarme</button>
                </div>
                <div v-if="status=='not_accepted' || !status" style="text-align:center">
                  <button type="button" class="btn boton-secundario">Registrarme</button>
                </div>
              </transition>
            </form>
          </transition>
        </div>
      </div>
    </div>

    <b-modal ref="contrato-modal" hide-footer title="Términos y condiciones">
      <div class="d-block text-center">
        <h4>Aquí van los términos y condiciones</h4>
        <b-button class="mt-2" variant="success" block @click="cerrarContrato">Cerrar</b-button>
      </div>
    </b-modal>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "register",

  data() {
    return {
      errorMessage: "",
      existeUsuario: false,
      adulto: false,
      arkidian: false,
      status: false,
      register: {
        nombre: "",
        apellido: "",
        mail: "",
        password: "",
        passwordC: ""
      }
    };
  },

  computed: {
    ...mapGetters(["pathAPI", "userLogged"])
  },

  methods: {
    hacerRegistro(register) {
      self = this;
      self.errorMessage = "";

      fetch(this.$store.state.pathAPI + "registracion.php", {
        method: "POST",
        body:
          "nombre=" +
          register.nombre +
          "&apellido=" +
          register.apellido +
          "&mail=" +
          register.mail +
          "&password=" +
          register.password +
          "&confirmacion=" +
          register.passwordC,
        headers: new Headers({
          "Content-Type": "application/x-www-form-urlencoded"
        })
      }).then(function(response) {
        if (response.ok) {
          var loginResponse = response.json();
          loginResponse.then(function(result) {
            if (result.resultado == "ERROR") {
              self.errorMessage = result.mensaje;
              sessionStorage.nombre = "";
              sessionStorage.usuario = "";
              if (
                result.mensaje ==
                "Ya existe un usuario con ese nombre, por favor seleccioná otro."
              ) {
                self.errorMessage =
                  "Ya existe un usuario con ese nombre, por favor seleccioná otro";
                self.existeUsuario = true;
              }
            } else {
              self.enviarCodigo(register.mail);
            }
          });
        } else {
          throw "Error en la llamada Ajax";
        }
      });
    },
    enviarCodigo(mail) {
      self = this;
      self.errorMessage = "";
      fetch(this.$store.state.pathAPI + "codigo.php", {
        method: "POST",
        body: "&mail=" + mail + "&tipo_codigo=REGISTRO",
        headers: new Headers({
          "Content-Type": "application/x-www-form-urlencoded"
        })
      }).then(function(response) {
        if (response.ok) {
          var loginResponse = response.json();
          loginResponse.then(function(result) {
            if (result.resultado == "ERROR") {
              self.errorMessage = result.mensaje;
              sessionStorage.nombre = "";
              sessionStorage.usuario = "";
            } else {
              self.$router.push({ path: "/CodigoSecreto/Registro/" + mail });
            }
          });
        } else {
          throw "Error en la llamada Ajax";
        }
      });
    },
    volver() {
      this.$router.push({ path: "/" });
    },
    verContrato() {
      this.$refs["contrato-modal"].show();
    },
    cerrarContrato() {
      this.$refs["contrato-modal"].hide();
    }
  },
  computed: {},
  components: {},

  mounted: function() {}
};
</script>

<style scoped>
.olvide-password {
  margin: 15px;
  padding: 5px 20px;
  border-radius: 20px !important;
  border: 0px !important;
  align-items: center;
  transition: 0.2s;
  cursor: pointer;
  font-size: 15px;
  font-family: "Patua One", cursive;
  color: rgb(93, 93, 93);
  text-align: center;
}
.olvide-password:hover {
  transition: 0.2s;
  z-index: 1;
  color: #9546af;
}
#login {
  background: url("/public/images/site/background-login.svg");
  background-repeat: repeat-x;
  background-size: 1000px;
  display: table;
  width: 100%;
  background-position-y: top;
}
.login {
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 10px;
  background-color: #e9ecef;
  border-radius: 15px;
  -webkit-box-shadow: -1px 20px 71px -39px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: -1px 20px 71px -39px rgba(0, 0, 0, 0.75);
  box-shadow: -1px 20px 71px -39px rgba(0, 0, 0, 0.75);
}
.close {
  padding: 0px;
  font-size: 40px;
  font-weight: 300;
}
.label {
  margin-bottom: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/startPage/Registrate.vue